import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconOpacityComponent } from "./med-icon-opacity.component";

@NgModule({
  declarations: [
    MedIconOpacityComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconOpacityComponent,
  ],
})
export class MedIconOpacityModule { }
